import { createFormAction } from 'redux-form-saga'
export const FORM_KEY = 'SYSTEM_FORM'
export const SystemFormAction = createFormAction(FORM_KEY)